import { render, staticRenderFns } from "./CandidateDocuments.vue?vue&type=template&id=683cdb90"
import script from "./CandidateDocuments.vue?vue&type=script&lang=js"
export * from "./CandidateDocuments.vue?vue&type=script&lang=js"
import style0 from "./CandidateDocuments.vue?vue&type=style&index=0&id=683cdb90&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683cdb90')) {
      api.createRecord('683cdb90', component.options)
    } else {
      api.reload('683cdb90', component.options)
    }
    module.hot.accept("./CandidateDocuments.vue?vue&type=template&id=683cdb90", function () {
      api.rerender('683cdb90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/components/CandidateDocuments.vue"
export default component.exports